import { FeedbackInput } from '@/client/services/api/graphql/gql/graphql';
import { graphQLClient } from '@/client/services/api/clients/graphqlClient';
import { sendExchangeFeedbackMutation } from '../api/mutations/sendExchangeFeedbackMutation';
import { useMutation } from '@tanstack/react-query';
import { useToastStore } from '@/client/services/state/toastStore';
import { useTranslation } from 'react-i18next';

export const useAddExchangeFeedback = () => {
  const { t } = useTranslation();
  const { setToast } = useToastStore();

  interface AddExchangeFeedbackProps {
    feedbackInput: FeedbackInput;
    id: string;
  }

  const addExchangeFeedback = useMutation({
    mutationFn: ({ feedbackInput, id }: AddExchangeFeedbackProps) =>
      graphQLClient.request(sendExchangeFeedbackMutation, { feedbackInput, id }),
    onSuccess: () =>
      setToast({
        show: true,
        status: 'success',
        title: t('aiAgent.feedback.success'),
      }),
    onError: () =>
      setToast({
        show: true,
        status: 'error',
        title: t('aiAgent.feedback.error'),
      }),
  });

  return {
    addExchangeFeedback,
  };
};
